'use client'
import React, { useState } from "react";
import UserFormModal from "@/components/UserFormModal";
import { Download } from "lucide-react";

const DownloadBroChure = ({ downloadUrl, brochureName, btnName }) => {
    const [open, setOpen] = useState(false);
    const [shouldDownload, setShouldDownload] = useState(false);

    const REDIRECT_URL = "https://application.msu.edu.in/campus-programme-registration";

    const handleFormSuccess = async () => {
        if (!shouldDownload) return;

        try {
            const response = await fetch(downloadUrl);
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.download = `${brochureName}.pdf`;
            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Download failed", error);
            // window.location.replace(REDIRECT_URL);
            window.open(downloadUrl, "_blank");

        } finally {
            setShouldDownload(false);
            setOpen(false);
        }
    };

    return (
        <div className="mt-6 md:mt-14 mb-0 md:mb-5 flex justify-center items-center w-full">
            <UserFormModal
                isOpen={open}
                onClose={() => setOpen(false)}
                onSuccess={handleFormSuccess}
                shouldDownload={shouldDownload}
            />

            <button
                onClick={() => {
                    setShouldDownload(true);
                    setOpen(true);
                }}
                className="bg-[#E09512] hover:bg-[#c97f0f] 
                text-white font-semibold text-base md:text-lg 
                px-6 py-3 rounded-lg shadow-md 
                border border-gray-200 
                hover:border-black/70
                hover:shadow-xl transition-all duration-300 cursor-pointer
                flex items-center justify-center gap-2"
            >{btnName} <Download size={18} />
            </button>
        </div>
    )
}

export default DownloadBroChure